<script lang="ts">
  import { onMount } from "svelte";
  import { patchWithJwt, serverlessRoutes, translate, errorTracker } from "lib";
  import { dialogData } from "stores";
  import { ButtonComponent, TextareaField } from "ui";

  let data: any;
  let disabled = true;
  let isLoading = false;

  const form = {
    text: { value: "", error: "" },
  };

  const onInput = (key: keyof typeof form): void => {
    if (key === "text") {
      if (form.text.value === "") {
        form.text.error = "FIELD_REQUIRED";
      } else if (form.text.value.length > 320) {
        form.text.error = "FIELD_MAXIMUM_320";
      } else {
        form.text.error = "";
      }
    }

    disabled = Object.values(form).some(({ error }) => error !== "");
  };

  const onSubmit = async (): Promise<void> => {
    isLoading = true;

    try {
      const response = await patchWithJwt(serverlessRoutes.COMMENT, {
        partialComment: {
          id: data.comment.id,
          text: form.text.value,
        },
      });

      data.executeFunction(response);

      $dialogData.type = "";
      $dialogData.data = {};
    } catch (error) {
      isLoading = false;
      errorTracker.captureError(error as Error | string, "error", {
        context: "comment_management",
        action: "edit_comment",
        commentId: data.comment.id
      });
    }
  };

  onMount((): void => {
    if (data.comment) {
      form.text.value = data.comment.text;
      onInput("text");
    }
  });

  export {data};
</script>

<div class="p-4 flex flex-col gap-4">

  <div class="text-center font-semibold">Izmeni komentar</div>

  <TextareaField
    id="text"
    label={translate("TEXT")}
    error={translate(form.text.error)}
    bind:value={form.text.value}
    on:input={() => onInput("text")}
  />

  <div class="flex justify-center">
    <ButtonComponent on:click={onSubmit} {isLoading} {disabled}>
      {translate("EDIT")}
    </ButtonComponent>
  </div>

</div>
